import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MovimientosService {

  constructor(private http: HttpClient) { }
 
  findById(idActivo: number): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/adquisiciones/activos/${idActivo}/movimientos`);
  }

  persistActaIngresoSalida(ingresoSalidaPersist: any): Observable<any> {  
    return this.http.post(`${environment.apiSecurityUrl}api/v1/ingresosalidas`, ingresoSalidaPersist); 
  }

  getActaIngresoSalida(idActivo: number, idUsuarioActual: number): void {
    window.open(`${environment.apiReportsUrl}api/v1/reports/ingresosalidas/${idActivo}/${idUsuarioActual}`, '_blank');
  }
}